<template>
  <div class="main">
    <p class="smallTitle dashboard">ダッシュボード</p>
    <p class="explane">
      各種カテゴリのオープンデータを閲覧しやすいダッシュボードとして掲載しています。<br />
      以下のカテゴリを選択ください。
    </p>
    <div class="categorys">
      <div class="item" v-for="item in items" :key="item.name">
        <img
          :src="item.img"
          :alt="item.categoryEn"
          class="itemImg"
          @click="goIndividual(item.categoryEn)"
        />
        <router-link
          :to="{
            name: 'dashboardIndividual',
            params: { categoryEn: item.categoryEn },
          }"
          class="itemName"
          >{{ item.name }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: []
    };
  },
  mounted() {
    var now = new Date();
    fetch("./json/dashboardDataList.json"+"?"+now.getTime())
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        for (var i = 0; i < data.length; i++) {
          this.items.push({
            name: data[i].name,
            img: data[i].img,
            categoryEn: data[i].categoryEn,
          });
        }
      });
  },
  methods: {
    goIndividual(enCategory) {
      this.$router.push({
        name: "dashboardIndividual",
        params: { categoryEn: enCategory },
      });
    },
  },
  computed: {
    imgPath() {
      return function (num) {
        return this.items[num].link;
      };
    },
  },
};
</script>

<style scoped>
.main {
  width: 80%;
  margin-top: 100px;
}

.smallTitle {
  font-size: 2.5vw;
  font-weight: 800;
  color: #072a40;
  position: relative;
  margin-bottom: 70px;
}

.smallTitle.dashboard::after {
  content: "DASHBOARD";
  font-size: 60%;
  color: #d9b97e;
  position: absolute;
  top: 100%;
  left: 0;
}

.explane {
  font-size: 1.5vw;
}

.categorys {
  margin: 30px 0 100px 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  row-gap: 50px;
}

.item {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.itemImg {
  width: 80%;
  aspect-ratio: 1/1;
  background-size: contain;
  cursor: pointer;
}

.itemName {
  font-size: 1.5vw;
  font-weight: 500;
}

a:link,
a:link,
a:visited,
a:hover,
a:active {
  color: black;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 10px;
}
</style>
